/**
 * ===========================================================================================
 * VISUAL DESIGN SYSTEM
 * ===========================================================================================
 *
 * PURPOSE:
 * Centralized color palette ensuring consistent brand-aligned visualizations
 * across all charts, cards, and UI elements. Optimized for dark theme accessibility.
 *
 * DESIGN PRINCIPLES:
 * - Uses CSS custom properties for theme consistency
 * - Higher luminosity values for dark theme readability
 * - Professional palette suitable for C-suite presentations
 * - Distinct colors for pillar differentiation
 */




// Brand-aligned color palette - dark mode compliant with enhanced differentiation
export const STRATEGIC_COLORS = {
    primary: 'hsl(var(--primary))',          // Primary brand color
    secondary: 'hsl(var(--secondary))',      // Secondary brand accent
    accent: 'hsl(var(--accent))',            // UI accent color
    muted: 'hsl(var(--muted))',              // Muted text/borders
    background: 'hsl(var(--background))',    // Card backgrounds
    foreground: 'hsl(var(--foreground))',    // Primary text
    teal: 'hsl(174 72% 56%)',                // #14B8A6 - Primary Teal (Account Reconciliation)
    blue: 'hsl(217 91% 60%)',                // #3B82F6 - Deep Blue (Journal Entry Automation)
    emerald: 'hsl(158 64% 52%)',             // #10B981 - Emerald Green (Intercompany)
    indigo: 'hsl(188,100%,22%)',              // #6366F1 - Indigo (Close Management)
    orange: 'hsl(25 95% 53%)',               // #F97316 - Orange (Other Processes)
    red: 'hsl(0 84% 70%)'                    // Error/warning states
}


// Predefined color sequence for task-level charts - enhanced differentiation
export const TASK_COLORS = [
    STRATEGIC_COLORS.teal,        // Primary Teal - Account Reconciliation
    STRATEGIC_COLORS.blue,        // Deep Blue - Journal Entry Automation
    STRATEGIC_COLORS.emerald,     // Emerald Green - Intercompany
    STRATEGIC_COLORS.indigo,      // Indigo - Close Management
    STRATEGIC_COLORS.orange,      // Orange - Other Processes
    'hsl(262 83% 58%)'           // Purple accent for additional tasks
]